import constants from '../../constants';
import { ConsentEvent } from './types';

// A corrupt or partially written session must not throw here. Falling back to
// no session sends an empty bearer token and surfaces an honest 401, which the
// panel already renders as an error state. Mirrors dataRetention/retentionApi.ts.
const getSession = () => {
  const raw = localStorage['session'];
  if (!raw || raw === 'undefined') {
    return null;
  }
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

// Read per request rather than once at module load, so a session that changes mid-session (or is
// written after this module is first imported) is picked up.
const getHeaders = (): Record<string, string> => {
  const session = getSession();
  return {
    ApiKey: constants.apikey || '',
    'Content-Type': 'application/json',
    Authorization: session?.key ? `bearer ${session.key}` : ''
  };
};

// The endpoint answers with the API's { success, data } envelope, so a 200 carrying
// success: false is still a failure and both checks are needed.
const handleApiResponse = async <T>(
  response: Response,
  failureMessage: string
): Promise<T> => {
  const json = await response.json();
  if (!response.ok || !json?.success) {
    throw new Error(failureMessage);
  }
  return json.data as T;
};

export const getAccountConsentEvents = async (
  accountId: number
): Promise<ConsentEvent[]> => {
  const response = await fetch(
    `${constants.baseApiHost}/api/v2/account/${accountId}/consent-events`,
    { headers: getHeaders() }
  );
  return handleApiResponse<ConsentEvent[]>(
    response,
    'consent events request failed'
  );
};
